import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .bonnie-layout.mobile-rows-1,
    .bonnie-layout.mobile-rows-1.has-subheader {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        var(--bottom-padding-height)
        [last-line];

      .subheader,
      .header,
      .cta-btn,
      .media,
      .description {
        grid-row: 2;
      }
    }

    .bonnie-layout.mobile-rows-2 {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        [last-line];

      .header,
      .cta-btn {
        grid-row: 2;
      }

      .media,
      .description {
        grid-row: 3;
      }
    }
    .bonnie-layout.mobile-rows-2.has-subheader {
      .subheader {
        grid-row: 2;
      }
      .header,
      .cta-btn,
      .media,
      .description {
        grid-row: 3;
      }
    }

    .bonnie-layout.mobile-rows-3 {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        [last-line];

      .header,
      .cta-btn {
        grid-row: 2;
      }
      .media {
        grid-row: 3;
      }
      .description {
        grid-row: 4;
      }
    }
    .bonnie-layout.mobile-rows-3.has-subheader {
      .subheader {
        grid-row: 2;
      }
      .header,
      .cta-btn {
        grid-row: 3;
      }
      .media,
      .description {
        grid-row: 4;
      }
    }

    .bonnie-layout.mobile-rows-4,
    .bonnie-layout.mobile-rows-4.has-subheader {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        [last-line];

      .subheader {
        grid-row: 2;
      }
      .header {
        grid-row: 3;
      }
      .media,
      .cta-btn {
        grid-row: 4;
      }
      .description {
        grid-row: 5;
      }
    }

    .bonnie-layout {
      max-width: 100%;
      align-items: end;
    }

    .subheader {
      font-size: 0.825em;
      line-height: 1.45em;
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .header {
      grid-column: 2 / 5;
      grid-row: 3;
    }

    .cta-btn {
      grid-column: 6 / 8;
      grid-row: 3;
      place-self: end;
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .image img {
      width: 100%;
    }

    .video {
      grid-column: 2 / 8;
      grid-row: 4;
      width: 100%;
      position: relative;
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 5;
    }

    .image-description {
      padding-top: 1em;
      border-top: 1px solid #c0c0c0;
      display: flex;
      justify-content: space-between;
      margin-top: calc(14rem / var(--default-rem-px-count));
    }

    .image-description > span > p {
      font-size: 0.825em;
      line-height: 1.45em;
      margin: 0;
    }

    .vertical-center {
      margin: auto 0;
    }

    @media (min-width: 600px) {
      .bonnie-layout.mobile-rows-1,
      .bonnie-layout.mobile-rows-1.has-subheader,
      .bonnie-layout.mobile-rows-2,
      .bonnie-layout.mobile-rows-2.has-subheader,
      .bonnie-layout.mobile-rows-3,
      .bonnie-layout.mobile-rows-3.has-subheader,
      .bonnie-layout.mobile-rows-4,
      .bonnie-layout.mobile-rows-4.has-subheader {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          var(--top-padding-height);
        align-items: start;
        h2 {
          line-height: unset;
        }

        .details-row {
          margin-bottom: var(--top-padding-height);
        }

        .subheader {
          grid-column: 3 / 6;
          grid-row: 2;
          margin-bottom: calc(10rem / var(--default-rem-px-count));
        }

        .header {
          grid-column: 3 / 7;
          grid-row: 3;
        }

        .description {
          grid-column: 8 / 11;
          grid-row: 3;
        }

        .cta-btn {
          grid-column: 12 / 14;
          grid-row: 3;
          place-self: baseline;
        }

        .video,
        .image {
          grid-column: 2 / 14;
          grid-row: 4;
        }
      }
    }
  `,
];
